export function getClientColorByKey(key) {
    let color = localStorage[key]
    if (color == null || color == undefined) {
        /* Default colors */
        if (key == "tertiary_color") {
            color = "#000000"
        } else {
            color = "#fed602"
        }
    }

    return color
}